import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
    REVIEW_MODAL_TYPE,
    selectRejectPopupSubmissionUuid,
    selectRejectPopupSubmissionProgressUuid,
    selectSelectedCampaignUuid,
    setReviewModalOpen,
    selectActivePageNum,
    MAX_PAGE_SIZE,
    selectSidebarStep,
    selectSubmissionListParams,
} from 'state/review'
import { rejectSubmission } from 'state/submissions'
import { RejectionForm } from 'components/Submissions/Review/Submissions/ProgressBlock/RejectOrVerify'

interface SingleRejectionFormProps {
    handleRejectTagChange: any
    type: REVIEW_MODAL_TYPE
}

const SingleRejectionForm: React.FC<SingleRejectionFormProps> = ({ handleRejectTagChange, type }) => {
    const dispatch = useDispatch()
    const selectedCampaignUuid = useSelector(selectSelectedCampaignUuid)
    const selectedSubmissionUuid = useSelector(selectRejectPopupSubmissionUuid)
    const selectedSubmissionProgressUuid = useSelector(selectRejectPopupSubmissionProgressUuid)
    const activePageNum = useSelector(selectActivePageNum)
    const selectedStep = useSelector(selectSidebarStep)
    const submissionListParams = useSelector(selectSubmissionListParams)
    const handleCancel = (): void => {
        dispatch(setReviewModalOpen(false))
    }

    const handleReject = (reason: string, tag_uuids: string[]): void => {
        if (selectedCampaignUuid) {
            dispatch(
                rejectSubmission({
                    campaignUuid: selectedCampaignUuid,
                    submissionUuid: selectedSubmissionUuid ? selectedSubmissionUuid : undefined,
                    submissionProgressUuid: selectedSubmissionProgressUuid ? selectedSubmissionProgressUuid : undefined,
                    reason,
                    tag_uuids,
                    type,
                    getSubmissionListPayload: {
                        offset: activePageNum * MAX_PAGE_SIZE,
                        stepUuid: selectedStep?.uuid,
                        ...submissionListParams,
                    },
                }),
            )
            handleCancel()
        }
    }
    return (
        <RejectionForm
            handleCancel={handleCancel}
            handleReject={handleReject}
            handleRejectTagChange={handleRejectTagChange}
        />
    )
}

export default SingleRejectionForm
